import {LeftOutlined, QuestionCircleOutlined} from '@ant-design/icons';
import {Button} from '@ds/components';

type NewTicketFooterProps = {
  loading: boolean;
  canContinue: boolean;
  onFaq: () => void;
  onCancel: () => void;
  onContinue: () => void;
};

const NewTicketFooter: React.FC<NewTicketFooterProps> = ({
  loading,
  canContinue,
  onFaq,
  onCancel,
  onContinue
}) => {
  return (
    <div className="flex shrink-0 flex-col border-t border-gray-03 bg-white">
      <button
        type="button"
        className="flex h-17.5 items-center justify-between bg-orange-wash p-2.5 text-orange"
        onClick={onFaq}
      >
        <span className="flex items-center gap-2">
          <QuestionCircleOutlined className="text-2xl" aria-hidden />
          <span className="text-body-sm">سوالات متداول</span>
        </span>
        <LeftOutlined aria-hidden />
      </button>
      <div className="flex gap-2.5 border-t border-gray-03 p-2.5">
        <Button fullWidth variant="outline" disabled={loading} onClick={onCancel}>
          انصراف
        </Button>
        <Button fullWidth loading={loading} disabled={!canContinue || loading} onClick={onContinue}>
          ادامه
        </Button>
      </div>
    </div>
  );
};

export default NewTicketFooter;
